import { IStoreRootState } from "@/store/interface";
import { GetterTree } from "vuex";
import { PaymentRequirementsHistoryGetter } from "./constants";
import { PaymentRequirementsHistoryState } from "./interface";

export default <GetterTree<PaymentRequirementsHistoryState, IStoreRootState>> {

	[PaymentRequirementsHistoryGetter.historyList]: (
		{ historyList }
	) => historyList,

	[PaymentRequirementsHistoryGetter.historyListLoading]: (
		{ historyListLoading }
	) => historyListLoading,

	[PaymentRequirementsHistoryGetter.historyFilters]: (
		{ historyFilters }
	) => historyFilters,

	[PaymentRequirementsHistoryGetter.historyPageIsEnd]: (
		{ historyPageIsEnd }
	) => historyPageIsEnd,

}